import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../SvgIcon';

export function CheckIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 -960 960 960">
            <path d="M382-218 130-470l75-75 177 177 375-375 75 75-450 450Z" />
        </SvgIcon>
    );
}
